import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { Notification } from './notification.service';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatSnackBarLabel],
  template: `
    <span matSnackBarLabel>{{ data.message }}</span>
    <button mat-icon-button type="button" aria-label="Close" (click)="snackBarRef.dismiss()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  `,
  host: { '[class.warning]': "data.configuration.severity === 'warning'" },
  styles: [`
    :host {
      display: flex;
      align-items: flex-start;
      background: #b71c1c;
      color: #fff;
      border-radius: 4px;
      margin-right: -8px;
    }
    :host.warning { background: #fff7e6; color: #3e2723; }
    [matSnackBarLabel] {
      min-width: 0;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      max-height: calc(100dvh - 100px);
      overflow-y: auto;
    }
    button { flex-shrink: 0; color: inherit; margin: 4px; }
  `],
})
export class NotificationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: Notification,
    public snackBarRef: MatSnackBarRef<NotificationComponent>,
  ) {}
}
